<template>
  <VueTypeaheadBootstrap
    v-model="search"
    :data="clientes"
    :serializer="serializer"
    :placeholder="placeholder"
    @input="findCliente"
    @hit="cliente = $event"
    class="form-control form-control-custom"
    :class="[stateClass]"
    :size="size"
  />
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions } from "vuex";
import { debounce } from "lodash";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {},
    placeholder: {
      type: String,
      default: "Buscar  ...",
    },
    uf: {
      type: String,
      default: null,
    },
    return_object: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    cliente: null,
    search: "",
    clientes: [],
  }),
  computed: {
    sizeClass() {
      return "form-control-" + this.size;
    },
  },
  methods: {
    ...mapActions("clientes", ["ActionFind", "ActionFindById"]),
    findCliente: debounce(async function () {
      let payload = { q: this.search };
      if (this.uf) {
        payload.estado_sigla = this.uf;
      }
      const clientes = await this.ActionFind(payload);
      this.clientes = clientes.data;
    }, 500),

    async setClienteByIbge(ibge) {
      if (ibge) {
        let cliente = await this.ActionFindById(ibge);
        if (cliente.id) {
          this.cliente = cliente;
        }
      }
    },
    serializer(item) {
      let response = item.nome;
      if (item.pessoa_juridica && item.pessoa_juridica.endereco.cidade) {
        response += " / " + item.pessoa_juridica.endereco.cidade.estado_sigla;
      } else if (item.pessoa_fisica && item.pessoa_fisica.endereco.cidade) {
        response += " / " + item.pessoa_fisica.endereco.cidade.estado_sigla;
      }
      return response;
    },
  },
  watch: {
    search: function (value) {
      if (value === "") {
        this.cliente = null;
      }
    },
    cliente: function () {
      if (this.cliente) {
        this.search = this.cliente.nome;
        this.clientes = [this.cliente];
        this.$emit("input", this.cliente.id);
      } else {
        this.$emit("input", null);
      }
    },
    value: function (value) {
      let ibge = this.return_object ? value.id : value;
      this.setClienteByIbge(value);
    },
  },
  async created() {
    if (this.$route.params.cliente_id) {
      await this.setClienteByIbge(this.$route.params.cliente_id);
    }

    if (this.value) {
      this.setClienteByIbge(this.value);
    }
  },
};
</script>

<style lang="scss">
.form-control-custom {
  margin-left: 0 !important;
  padding-left: 0 !important;
  padding-top: 0 !important;

  .form-control {
    border: none !important;
    background: transparent !important;
  }
}
</style>
